export enum FilterTypesEnum {
    SEARCH_PRICER = 'SEARCH_PRICER',
    BATCH_PRICER = 'BATCH_PRICER',
}
